import axios from "axios";
import {
    ADD_SCENARIO_VARIATION_ITEMS,
    ADD_VARIATION_UUID_TO_LIST,
    ADD_VARIATION_NAME_TO_LIST,
    ADD_GROUP,
    SET_CREATE_GROUP_REQUEST,
    SET_CREATE_GROUP_SUCCESS,
    SET_CREATE_GROUP_ERROR,
    ADD_BULK_VARIATION_TO_LIST,
    ADD_BULK_VARIATION_COUNT,
    SET_CURRENT_PAGE_NUMBER,
} from "../../../../constants/CM/cm_open_loop/fusionDataCollection/addToCartFusionDataCollectionConstants";

export const cartCountUpdate = (data) => {
    return {
        type: ADD_SCENARIO_VARIATION_ITEMS,
        count: data.count,
        items: data.items,
    };
};

export const selectedScenarioUuidList = (variationUuid) => {
    return {
        type: ADD_VARIATION_UUID_TO_LIST,
        variationUuidList: variationUuid,
    };
};

export const selectedScenarioNameList = (variationName) => {
    return {
        type: ADD_VARIATION_NAME_TO_LIST,
        variationNameList: variationName,
    };
};

export const addGroupToCart = (obj) => {
    return {
        type: ADD_GROUP,
        group: obj.group,
    };
};

export const addVariationToGroup = (url, data) => (dispatch) => {
    try {
        dispatch({ type: SET_CREATE_GROUP_REQUEST });
        axios({
            url: url,
            method: "POST",
            data: data,
        })
            .then((response) => {
                if (response && response.status === 200) {
                    console.log("create group response", response);
                    dispatch({
                        type: SET_CREATE_GROUP_SUCCESS,
                        variationGroupStatus: response.data,
                    });
                } else {
                    dispatch({
                        type: SET_CREATE_GROUP_ERROR,
                        payload: "Error occured while fetching the request",
                    });
                }
            })
            .catch((error) => {
                if (
                    Object.prototype.hasOwnProperty.call(error, "response") &&
                    Object.prototype.hasOwnProperty.call(error.response, "data") &&
                    Object.prototype.hasOwnProperty.call(error.response.data, "message")
                ) {
                    dispatch({
                        type: SET_CREATE_GROUP_ERROR,
                        payload: error.response.data.message,
                    });
                } else {
                    dispatch({
                        type: SET_CREATE_GROUP_ERROR,
                        payload: "Something Went Wrong, Please Try Again!!",
                    });
                }
            });
    } catch (error) {
        console.log("error msg", error);
        const errorMsg = error.message || "Error occurred while fetching this request!";
        dispatch({ type: SET_CREATE_GROUP_ERROR, payload: errorMsg });
    }
};

export const resetVariationToGroupError = () => (dispatch) => {
    dispatch({ type: SET_CREATE_GROUP_ERROR, payload: "" });
};

export const bulkSelectedScenarioList = (selectedScenarioObj) => (dispatch) => {
    dispatch({ type: ADD_BULK_VARIATION_TO_LIST, selectedScenarioObjectList: selectedScenarioObj });
};

export const cartCount = (variationCount) => (dispatch) => {
    dispatch({ type: ADD_BULK_VARIATION_COUNT, totalBulkVariationSelected: variationCount });
};

export const setCurrentPageNumber = (currentPageNumber) => (dispatch) => {
    dispatch({ type: SET_CURRENT_PAGE_NUMBER, currentPageNumber: currentPageNumber });
};
